// extracted by mini-css-extract-plugin
export default {"mainContainer":"Home_mainContainer__nOV4U","gridContainer":"Home_gridContainer__xKN4z","gridItem":"Home_gridItem__yE1Zw","methodTitle":"Home_methodTitle__RN-Sk"};